import React from 'react'
import "./NavBar.css"
import profile_image from "../../asserts/admin_img.png"
import { useSelector } from 'react-redux';

const NavBar = () => {
  const { user } = useSelector(State => State.authState)
  return (

    <div className='navbar'>
      <div className="nav_container">
        <div className="nav_left">
        </div>
        <div className="nav_right">
          <div className='nav_right_container'>

            <div to={"/profile"}>  <img src={profile_image} alt="prof" /></div>
            <p><span>{user?.role}</span></p>
          </div>
        </div>

      </div>
    </div>
  )
}

export default NavBar
